module.exports = __webpack_public_path__ + "b6958d35cd381d0d15683ed5735ac64e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/feedback-2.png
// module id = 1722
// module chunks = 0